// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gsKa","top":"styles_top__2Yjvh","left":"styles_left__fwvBr","description":"styles_description__JC5ER"};